export default {"src":"/_next/static/media/assistant-cook.de087c6e.svg","height":269,"width":270};